import React, { useEffect ,useState} from "react";
import { useSelector,useDispatch } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Button, Label, Table } from 'reactstrap';
import { AppRolePermission } from '../../../../../action/authenticateUser';
import { GetLicenseInformation } from '../../../../../action/Administration/administrationAction';
import Print from "@mui/icons-material/Print";
import TraneLogo from '../../../../../Assets/images/green-trane-BA-logo.png';
import {
    getDevicePanelDetails,
    activatePanelLicense,
    deactivatePanelLicense,
  } from '../../../../../action/Administration/license';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import SelectAllCheckboxes from '../../../../../Resources/SelectAllCheckboxes';

const ViewPanelLicensing = ({ IsOnPremises=true, BackToLicense}) => {

    /*map dispatch to props*/
    const dispatch = useDispatch()
    
    /*map state to props*/
    const label = useSelector(state => state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference);
    const CommonLabel = useSelector(state => state.CommonResourceDataRootReducer.CommonResourcesData);
    const licenseAccess = useSelector(state => state.authService.HasApplicationFullAcess);
    const VersionNumber = useSelector(state => state.InstallationsRootReducer.ApplicationVersion);
    const licenseInfo = useSelector(state => state.InstallationsRootReducer.License);
    var panelDetails = useSelector(state => state.InstallationsRootReducer.DevicePanelDetails);

    /*state declarations */
    const [isFullAccess, setIsFullAccess] = useState(false);
    const [isSort, setIsSort] = useState(
        {column: null, 
         direction:[
            { name: 'siteName', direction: 'desc', onclick: true },
            { name: 'panelName', direction: 'desc', onclick: false },
            { name: 'modelName', direction: 'desc', onclick: false },
            { name: 'device_ID', direction: 'desc', onclick: false },
            { name: 'licenseCount', direction: 'desc', onclick: false },
            { name: 'isAppliedToLicense', direction: 'desc', onclick: false },
         ]
        }
    );
    const [isDefaultSort, setIsDefaultSort] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        dispatch(AppRolePermission(5,10));
        dispatch(GetLicenseInformation());
        dispatch(getDevicePanelDetails());
    }, [])

    useEffect(()=>{
        if(licenseAccess != null && licenseAccess){
            setIsFullAccess(true)
        }else{
            setIsFullAccess(false)
        }

    },[licenseAccess])

    const onSort = (column) => (e) => {
        setIsDefaultSort(false);
        var SortData = isSort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state =  panelDetails;
        var notequals = 0, array;
        if (data_from_state != null) {
            const sortedData =  data_from_state.sort((a, b) => {
                let nameA, nameB;
                if (column === "siteName" || column === "panelName" || column === "modelName" || column === "isAppliedToLicense") {
                    nameA = (column === "isAppliedToLicense") ? a[column] : a[column].toLowerCase();
                    nameB = (column === "isAppliedToLicense") ? b[column] : b[column].toLowerCase();
                    if (nameA < nameB) {
                        notequals = 1;
                        return -1;
                    }
                    if (nameA > nameB) {
                        notequals = 1;
                        return 1;
                    }
                    if (nameA === nameB) {
                        return 0;
                    }
                    return 0;
                }
                else{
                    return 0;
                }

            });
            if (selected[0].direction === 'asc' && notequals === 1) {
                sortedData.reverse();
            }
            if (selected[0].name === "siteName") {
                SortData[0].direction = direction;
                array = isSort.direction;
                array.map(x => (x.name !== "siteName") ? x.onclick = false : x.onclick = true);
                SortData = array;
            }
            if (selected[0].name === "panelName") {
                SortData[1].direction = direction;
                array = isSort.direction;
                array.map(x => (x.name !== "panelName") ? x.onclick = false : x.onclick = true);
                SortData = array;
            }
            if (selected[0].name === "modelName") {
                SortData[2].direction = direction;
                array = isSort.direction;
                array.map(x => (x.name !== "modelName") ? x.onclick = false : x.onclick = true);
                SortData = array;
            }
            if (selected[0].name === "isAppliedToLicense") {
                SortData[5].direction = direction;
                array = isSort.direction;
                array.map(x => (x.name !== "isAppliedToLicense") ? x.onclick = false : x.onclick = true);
                SortData = array;
            }

            panelDetails = sortedData;
            setIsSort({
                column,
                direction: SortData
            })        
        }
        ResetCheckBoxes();
    };

    const onSortNumber = (column) => (e) => {
        setIsDefaultSort(false);
        var SortData = isSort.direction;
        var selected = SortData.filter(a => a.name === column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state =  panelDetails;
        var array;
        if (data_from_state != null) {
            const sortedData =  data_from_state.sort((a, b) => {
                let nameA, nameB;
                nameA = a[column];
                nameB = b[column];
                return (nameA - nameB);

            });
            if (selected[0].direction === 'asc') {
                sortedData.reverse();
            }
            if (selected[0].name === "device_ID") {
                SortData[3].direction = direction;
                array = isSort.direction;
                array.map(x => (x.name !== "device_ID") ? x.onclick = false : x.onclick = true);
                SortData = array;
            }
            if (selected[0].name === "licenseCount") {
                SortData[4].direction = direction;
                array = isSort.direction;
                array.map(x => (x.name !== "licenseCount") ? x.onclick = false : x.onclick = true);
                SortData = array;
            }
            panelDetails = sortedData;
            setIsSort({
                column,
                direction: SortData
            })        
        }
        ResetCheckBoxes();
    }

    const panelListTable = () => {
        if(panelDetails !== null && panelDetails !== undefined && panelDetails.length !== 0){
            if (isDefaultSort) {
                panelDetails.sort((a, b) => {
                    let nameA = a['siteName'].toLowerCase();
                    let nameB = b['siteName'].toLowerCase();

                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    if (nameA === nameB) {
                        return 0;
                    }
                    return 0;
                });
                panelDetails.reverse();
            }
            return panelDetails.map((el,index) => (
                <tr key={index}>
                    <td className="printstlye"><input type="checkbox" siteid={el.siteID} deviceid={el.device_ID} className="PanelRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("PanelRows", "panel_header_Check_box")}}/></td>
                    <td>{el.siteName}</td>
                    <td>{el.panelName}</td>
                    <td>{el.modelName}</td>
                    <td>{el.device_ID}</td>
                    <td>{el.licenseCount.toFixed(3)}</td>
                    <td>{el.isAppliedToLicense ? label['ViewPanelLicensing.lblYes.Text'] : label['ViewPanelLicensing.lblNo.Text']}</td>
                </tr>
            ))
        }else{
            return <tr><td colSpan="7">{label['NoRecords.Text']}</td></tr>
        }
    }

    const OpenPrintPreview = () => {
        var imgURL = document.getElementById('test_trane_logo').src;
        var ltable = document.getElementById('tbl_print_panel_lic').outerHTML;
        var Footer_1 = CommonLabel['footer.copyright.Text'] !== undefined ? CommonLabel['footer.copyright.Text'] : '© 2022 Trane';
        var Footer_2 = CommonLabel['ContextHeaderText.Tracer.Text'] !== undefined ? CommonLabel['ContextHeaderText.Tracer.Text'] : 'Tracer® Ensemble™';
        var Footer_3 = CommonLabel['footer.lblversion.Text'] !== undefined ? CommonLabel['footer.lblversion.Text'] : 'Version';
        var Footer = Footer_1 + "&nbsp;&nbsp;" + Footer_2 + "&nbsp;&nbsp;" + Footer_3 + "&nbsp;" + VersionNumber;
        var lblFooterText = "<span>"+Footer+"</span>";
        var CurrentTime = new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false })
        var CurrentDate = new Date().toDateString() + ' ' + CurrentTime;
        var ActiveLicense = licenseInfo !== undefined && licenseInfo !== null && licenseInfo.length && licenseInfo[0].activeLicenses !== undefined  ? licenseInfo[0].activeLicenses : "";
        
        var WindowHeight = ((window.screen.height)-200) + 'px';
        var WindowWidth = ((window.screen.width)-200) + 'px';
        var printWindow = window.open('', 'printwindow', 'height='+WindowHeight+', width='+WindowWidth+', resizable=1, scrollbars=yes');
        
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;"><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');
        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div>");
        writeMe += ("<table cellspacing='0' cellpadding='0' border='0' style='width:100%'><tbody>");
        writeMe += ("<tr><td><img class='img_print' src="+imgURL+"></td></tr>");
        writeMe += ("<tr><td><div style='padding-left: 9px; padding-top: 15px;'><span id='lblTitleHeaderName' class='PageTitleBar' style='padding-left: 0px;'>View Device Licensing</span></div></td></tr>");
        writeMe += ("<tr><td><div style='padding-left: 9px; padding-top: 15px;'><legend id='lblLicenseInformation' class='EnsembleCustomContentHeading' style='margin-bottom:12px;'>License Information</legend></div></td></tr>");
        writeMe += ("<tr><td><div style='padding-left: 9px; padding-top: 15px;'><div class='divWrapper' style='marginBottom: 0px;'><div class='labelWrapper' style='width: 8%;'><span class='ContentLabel_OnPremise'>Active Licenses</span></div><Label class='ContentTextNoFloat'>"+ActiveLicense+"</Label></div> </div></td></tr>");
        writeMe += ("<tr><td><div id='divPrintPreviewPnl' style='padding-left: 9px; padding-top: 15px; width: 78%;'>"+ltable+"</div></td></tr>");
        writeMe += ("<tr><td><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/></td></tr>");
        writeMe += ("<tr><td><div class='print_footer' style='padding-left:9px; padding-bottom:10px;'>"+lblFooterText+"<span style='float:right;padding-right:15px;'>"+CurrentDate+"</span></div></td></tr>");
        writeMe += ("<tr><td>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #333;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 80px;height: 30px;margin-left: 9px; margin-top:3px; margin-right:10px; width:106px' id='btnPrint' onclick='javascript:window.close();' >Close Window</button>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #333;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;margin-left: 6px; margin-top:3px' id='btnPrint' onclick='javascript:window.print();' >Print</button>");
        writeMe += ("</td></tr>");
        writeMe += ("</tbody></table>");
        writeMe += ("</div><br/>");
        writeMe += ('</body></html>');    
        printWindow.document.write(writeMe);
        printWindow.document.close(); 
        if (window.focus) {
            printWindow.focus();
        }
    }

    const activateLicense = (value) => {
        setIsError(false);
        var data = [];
        var checkboxes = document.getElementsByClassName('PanelRows');
        for(var i=0; i<checkboxes.length; i++){
            if(checkboxes[i].checked){
                var devices_to_be_licensed = {
                    "SiteID": checkboxes[i].getAttribute('siteid'),
                    "DeviceID":checkboxes[i].getAttribute('deviceid')
                }
                data.push(devices_to_be_licensed);
            }
        }
        if(data.length){
            if(value){
                dispatch(activatePanelLicense(data));
            }  
            else{
                dispatch(deactivatePanelLicense(data));
            }  
            ResetCheckBoxes();
        }else{
            setIsError(true);
        }
    }

    const ResetCheckBoxes = () => {
        document.getElementsByClassName('panel_header_Check_box')[0].checked = false;
        let elements = document.getElementsByClassName('PanelRows');
        Array.from(elements).map(element => element.checked = false); 
    }

    return (
        <div className="main_container" style={{"padding-top":"10px"}}>
            <div className="pnl_view_header">
                <span id="lblTitleHeaderName" className="PageTitleBar" style={{ "padding-left": "0px" }}>{label['ViewPanelLicensing.lblViewPanelLicensing.Text'] !== undefined ? label['ViewPanelLicensing.lblViewPanelLicensing.Text'] : "View Device Licensing" }</span>
                <Print className="pnl_print_icon" onClick={() => OpenPrintPreview()} />
            </div>
            <div>
                <Label id="lblUserAsstAdmin" className="ContentTextNoFloat" style={{"padding-left":"0px", "margin-bottom":"20px"}}>{label['ViewPanelLicensing.lblUserAsstMessageViewPanelLicensing.Text'] !== undefined ? label['ViewPanelLicensing.lblUserAsstMessageViewPanelLicensing.Text'] : "This page shows the licensing status of each of the panels registered with Tracer ES." }</Label>
            </div>
            {
                isError ?  <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo"/>{label['ViewPanelLicensing.Error2.Text']}</p> : <></>
            }
            <legend id="lblLicenseInformation" className={IsOnPremises ? "EnsembleCustomContentHeading" : "PageTitleBar"} style={{"margin-bottom":"12px"}}>{label['RegisterTESSiteLicense.LicenseInfo.Title.Text'] !== undefined ? label['RegisterTESSiteLicense.LicenseInfo.Title.Text'] : "License Information"}</legend>
            <div className='divWrapper' style={{ marginBottom: '0px' }}>
                <div className="labelWrapper" style={{width: '15%'}}>
                    <span className="ContentLabel_OnPremise">{label['ViewPanelLicensing.lblLicenseUsed.Text'] !== undefined ? label['ViewPanelLicensing.lblLicenseUsed.Text'] : "Active Licenses"}</span>
                </div>
                <Label id="lblLicenseUsedValue" className="ContentTextNoFloat">{licenseInfo !== undefined && licenseInfo !== null && licenseInfo.length && licenseInfo[0].activeLicenses !== undefined  ? licenseInfo[0].activeLicenses : ""}</Label>
            </div> 
            <div className="btns_group row form-group" style={{"margin-top":"15px"}}>
                <div className="col-sm-10">
                    <Button type="button" id="btnActivateLicenses" style={{"margin-left" : "0px", "float": "left", display: isFullAccess ? 'block' : 'none'}} className="btn_Panellic" onClick={() => activateLicense(true)}>{label['ViewPanelLicensing.btnActivateLicenses.Text'] !== undefined ? label['ViewPanelLicensing.btnActivateLicenses.Text'] : "Activate Licenses"}</Button>
                    <Button type="button" id="btnDeactivateLicenses" style={{"margin-left" : "12px", "float": "left", display: isFullAccess ? 'block' : 'none'}} className="btn_Panellic" onClick={() => activateLicense(false)}>{label['ViewPanelLicensing.btnDeactivateLicenses.Text'] !== undefined ? label['ViewPanelLicensing.btnDeactivateLicenses.Text'] : "Deactivate Licenses"}</Button>
                </div>
            </div>
            <Table striped responsive className="Custom_table fixed_layout" id="tbl_print_panel_lic">
                <tbody className="cell_container">
                    <tr>
                        <th width="5%" className="printstlye"><input type="checkbox" className="panel_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("PanelRows", "panel_header_Check_box")}}/></th>
                        <th onClick={onSort('siteName')} className="wo_cursor">
                            <span>{label['Administration.ViewPanelSiteName.Text'] !== undefined ? label['Administration.ViewPanelSiteName.Text']: 'Building Name'}</span>
                            <span className={(isSort.direction[0].name === "siteName") ?
                            (isSort.direction[0].onclick) ? (isSort.direction[0].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                : (isSort.direction[0].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                            </span>
                        </th>
                        <th onClick={onSort('panelName')} className="wo_cursor">
                            <span>{label['Administration.ViewPanelName.Text'] !== undefined ? label['Administration.ViewPanelName.Text'] : 'Device Name'}</span>
                            <span className={(isSort.direction[1].name === "panelName") ?
                            (isSort.direction[1].onclick) ? (isSort.direction[1].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                : (isSort.direction[1].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                            </span>
                        </th>
                        <th onClick={onSort('modelName')} className="wo_cursor">
                            <span>{label['Administration.ViewPanelType.Text'] !== undefined ? label['Administration.ViewPanelType.Text'] : 'Model Name'}</span>
                            <span className={(isSort.direction[2].name === "modelName") ?
                            (isSort.direction[2].onclick) ? (isSort.direction[2].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                : (isSort.direction[2].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                            </span>
                        </th>
                        <th onClick={onSortNumber('device_ID')} className="wo_cursor">
                            <span>{label['Administration.ViewPanelID.Text'] !== undefined ? label['Administration.ViewPanelID.Text'] : 'Device ID'}</span>
                            <span className={(isSort.direction[3].name === "device_ID") ?
                            (isSort.direction[3].onclick) ? (isSort.direction[3].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                : (isSort.direction[3].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                            </span>
                        </th>
                        <th onClick={onSortNumber('licenseCount')} className="wo_cursor">
                            <span>{label['Administration.ViewPanelLicenseValue.Text'] !== undefined ? label['Administration.ViewPanelLicenseValue.Text'] : 'Licenses Required by this Device'}</span>
                            <span className={(isSort.direction[4].name === "licenseCount") ?
                            (isSort.direction[4].onclick) ? (isSort.direction[4].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                : (isSort.direction[4].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                            </span>
                        </th>
                        <th onClick={onSort('isAppliedToLicense')} className="wo_cursor">
                            <span>{label['Administration.ViewActiveStatus.Text'] !== undefined ? label['Administration.ViewActiveStatus.Text'] : 'License is Active'}</span>
                            <span className={(isSort.direction[5].name === "isAppliedToLicense") ?
                            (isSort.direction[5].onclick) ? (isSort.direction[5].direction === "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                : (isSort.direction[5].direction === "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                            </span>
                        </th>
                    </tr>
                    {panelListTable()}
                </tbody>
            </Table>
            <div className="btns_group row form-group" style={{"margin-top": "50px"}}>
                <div className="col-sm-10" style={{"padding-bottom": "30px"}}>
                    <button type="button" id="btnBack" onClick={() => BackToLicense(false)} className="btn_Panellic" style={{"margin-left" : "0px", width : "auto"}}>{"<"} {label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] !== undefined ? label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] : "Tracer Ensemble Licensing"}</button>
                </div>
            </div>
            <div>
                <img id="test_trane_logo" alt="Trane" src={TraneLogo} style={{ "display": "none" }} />
            </div>
        </div>
    )
}

export default withRouter(ViewPanelLicensing);